import type { TextI, TickerI } from "tweenly"
import PauseCircleIcon from "@mui/icons-material/PauseCircle"
import PlayCircleIcon from "@mui/icons-material/PlayCircle"
import { Box, Button } from "@mui/material"
import { t } from "i18next"
import { useDispatch } from "react-redux"
import { updateTickerAnimationAction } from "../../../../store/slices/objects.slice"
import ExpandableSection from "../../../common/ExpandableSection"
import PropertyRow from "../../../common/PropertyTools/PropertyRow"
import { TickerInput } from "./TickerInput"
interface Props {
    object: TickerI
    maskObject: TickerI | undefined
    textObjects: TextI[]
    playTimeline: () => void
    pauseTimeline: () => void
}
const ScrollTools = ({ object, maskObject, textObjects, playTimeline, pauseTimeline }: Props) => {
    const dispatch = useDispatch()
    const duration = maskObject && maskObject.duration ? maskObject.duration : 0

    const delay = maskObject && maskObject.delay ? maskObject.delay : 0

    const handleOnChange = (e: any) => {
        if (maskObject) {
            dispatch(
                updateTickerAnimationAction({
                    property: e.target.name,
                    value: e.target.value,
                    objectId: maskObject.id,
                    updatedAt: Date.now(),
                })
            )
        }
    }
    return (
        <ExpandableSection
            expanded={true}
            title={t("editor:tickers.scrollTitle")}
            component={
                <Box display="flex" flexDirection="column" gap={1.5} width="100%" pb={0.5}>
                    <PropertyRow>
                        <Box display="flex" gap={1}>
                            <Box flex={1} minWidth={0}>
                                <TickerInput
                                    inputValue={duration}
                                    handleOnChange={handleOnChange}
                                    name={t("editor:tickers.durationName")}
                                    label={t("editor:tickers.duration")}
                                />
                            </Box>
                            <Box flex={1} minWidth={0}>
                                <TickerInput
                                    inputValue={delay}
                                    handleOnChange={handleOnChange}
                                    name={t("editor:tickers.delayName")}
                                    label={t("editor:tickers.delay")}
                                />
                            </Box>
                        </Box>
                    </PropertyRow>
                    <PropertyRow>
                        <Box display="flex" gap={1}>
                            <Button
                                startIcon={<PlayCircleIcon />}
                                color="success"
                                variant="text"
                                onClick={() => playTimeline()}
                            >
                                {t("play")}
                            </Button>
                            <Button
                                startIcon={<PauseCircleIcon />}
                                color="error"
                                variant="text"
                                onClick={() => pauseTimeline()}
                            >
                                {t("stop")}
                            </Button>
                        </Box>
                    </PropertyRow>
                </Box>
            }
        />
    )
}

export default ScrollTools
